import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { StatsigService } from '@app/services/statsig.service';
import { displayDemoModeAlert, inDemoMode } from '@app/lib/remote-login';

export interface IStatsigFeatureGuardConfig {
  name: string;
  redirectTo?: string;
  checkFeatureGateOnlyInDemoMode?: boolean;
  useNegatedCheck?: boolean;
}

@Injectable()
export class FleetCardsFeatureGuard implements CanActivate {
  constructor(private statsigService: StatsigService, private router: Router) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const config: IStatsigFeatureGuardConfig = route.data.statsigFeatureGuard;
    const { name, redirectTo, checkFeatureGateOnlyInDemoMode, useNegatedCheck } = config;

    if ((checkFeatureGateOnlyInDemoMode && !inDemoMode()) ||
         (useNegatedCheck ? !this.statsigService.evaluateGate(name) : this.statsigService.evaluateGate(name))) {
      return true;
    } else {
      if (checkFeatureGateOnlyInDemoMode && inDemoMode()) displayDemoModeAlert();
      if (redirectTo) {
        this.router.navigate([redirectTo]);
      }
    }
    return false;
  }
}
